import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServicioIncapacidadService {
  
  private REPORTES_API: string = '';

  constructor(
    private http: HttpClient,
  ) {
    this.REPORTES_API = environment.API_REPORTES;
  }

  public getIncapacidades(code: string, unco: number, tipo: number) {
    const URL = `${this.REPORTES_API}/incapacidad/?code=${code}&unco=${unco}&tipo=${tipo}`;
    const HTTP_HEADER = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.get(URL, { headers: HTTP_HEADER });
  }

}
